import { Component, OnInit } from '@angular/core'
import { ActivatedRoute } from '@angular/router'

@Component({
  selector: 'se-po-household-setup-feature-unsubscribe-success-docs',
  templateUrl: './unsubscribe-success-docs.component.html',
  styleUrls: ['./unsubscribe-success-docs.component.scss'],
  standalone: false,
})

export class UnsubscribeSuccessDocsComponent implements OnInit {
  public seIcon: string

  constructor(
    private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    this.route.snapshot.queryParams = {
      org_name: 'The Cathletes',
      org_logo_url: 'https://se-portal-staging.s3.amazonaws.com/uploads/288461/medium_44efdeea8d598c04aba175db596a43d5.png',
      email_address: 'me@mail.com'
    }
  }
}
